import Pin from "./SVG/pin.svg?react";

const PinIcon = () => {
  return <Pin />;
};

export default PinIcon;
